export const USER_ROLES = {
  CLIENT_AGENT: "SALES",
  STORE_MANAGER: "STORE_MANAGER",
  REGION_MANAGER: "AREA_MANAGER",
};

export const ROLES = {
  ...USER_ROLES,
  CUSTOMER: "CUSTOMER",
  GUEST: "GUEST",
};

export const ALL_USER_ROLES = Object.values(USER_ROLES);
